import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import debounce from 'es6-promise-debounce';
import fetch from 'isomorphic-fetch';
import { css } from '@emotion/core';
import { FiMenu, FiX } from 'react-icons/fi';
import { FaChevronDown } from 'react-icons/fa';

import {
  primary_light,
  primary_s15_l20,
  primary_s98_l83,
} from '../../lib/colors';
import Assistenza from '../../Icons/Assistenza';
import Spedizione from '../../Icons/Spedizione';
import Search from '../../Icons/Search';
import Login from '../HeaderMenu/Login/Login';
import LoginIcon from '../../Icons/Login';
import IndexLink from '../../IndexLink/IndexLink';
import Link from '../../Link/Link';
import AsyncSelect from '../../../shared/AsyncSelect/AsyncSelect';
import A from '../../Anchor/Anchor';
import Button from '../../Button/Button';
import Price from '../../Price/Price';
import MegaMenu from './MegaMenu/MegaMenu';
import CartMenu from './CartMenu/CartMenu';
import ProductAutocomplete from '../../ProductAutocomplete/ProductAutocomplete';
import api from '../../../../api';
import { showHeaderMenu } from '../../../../redux/modules/showHeaderMenu';
import { ga4Search } from '../../lib/ga4EnhancedEcommerce';
import { fkmxSearch } from '../../lib/farmakomMetrics';
import { gtmToGa4Search } from '../../lib/gtmEnhancedEcommerce';

import './HeaderMenu.scss';
import { ImageDispatcher } from '../../ImageDispatcher/ImageDispatcher';

class HeaderMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedMegaMenuType: '',
      showMegaMenu: false,
      showCartMenu: false,
      showLogin: false,
    };
  }

  // GET CATEGORIES
  getCategories(type) {
    if (!type) {
      return [];
    }
    // Prodotti o Farmaci
    if (type === 'prodotti' || type === 'farmaci') {
      return !!this.props.categories && !!this.props.categories.length
        ? this.props.categories.filter(cat => cat.type === type)
        : [];
    }
    // TAG
    const tag = this.props.categoryTags.find(t => t.name === type);
    if (tag) {
      return tag.categories;
    }
    return [];
  }

  // TOGGLE MEGA MENU
  toggleMegaMenu = type => event => {
    const { showMegaMenu, selectedMegaMenuType } = this.state;

    event.preventDefault();

    // Se è già aperto
    if (showMegaMenu) {
      if (selectedMegaMenuType !== type) {
        // Stiamo cliccando l'altro Link
        this.setState({
          selectedMegaMenuType: type,
        });
      } else {
        this.setState({
          showMegaMenu: false,
          selectedMegaMenuType: null,
        });
      }
    } else {
      // Chiuso => Aprire
      this.setState({
        showMegaMenu: true,
        selectedMegaMenuType: type,
      });
    }
  };

  getOptions = input => {
    const { endpoint, method, headers, body } = api.searchProductsByKeywords(
      input,
      1,
      4
    );

    const headersWithStoreId = {
      ...headers,
      storeid: this.props.storeId,
    };

    if (input.length > 1) {
      // GTM USER SEARCH
      if (this.props.hasGoogleTagManager) {
        gtmToGa4Search(input);
      }
      // GA4 USER SEARCH
      if (this.props.hasGoogleAnalytics4Advanced) {
        ga4Search(input);
      }
      // FKMX USER SEARCH
      if (this.props.hasFarmakomMetrics) {
        fkmxSearch(input);
      }

      return fetch(endpoint, { method, headers: headersWithStoreId, body })
        .then(response => {
          return response.json();
        })
        .then(json => {
          if (json.items.length === 4) {
            json.items.unshift({
              id: -1,
              name: 'Vedi tutti',
              searchKeywords: input,
            });
          }
          return {
            options: json.items.map(item => ({
              ...item,
              path: `/${item.type}/${item.categorySeoName}/${
                item.subcategorySeoName ? item.subcategorySeoName : '_'
              }/${encodeURIComponent(item.seoName)}`,
            })),
          };
        });
    }
    return Promise.resolve([]);
  };

  getOptionsDebounced = debounce(this.getOptions, 500);

  getOptionsDoofinder = input => {
    const {
      endpoint,
      method,
      headers,
      body,
    } = api.getProductsByKeywordsDoofinder(
      input,
      1,
      5,
      this.props.doofinderHashId
    );

    if (input.length >= 3) {
      // GA4 USER SEARCH
      if (this.props.hasGoogleAnalytics4Advanced) {
        ga4Search(input);
      }

      // FKMX USER SEARCH
      if (this.props.hasFarmakomMetrics) {
        fkmxSearch(input);
      }

      return fetch(endpoint, { method, body })
        .then(response => {
          return response.json();
        })
        .then(json => {
          let options = json.results.map(result => ({
            id: result.id,
            image: result.image_link || result['image link'],
            name: result.title,
            path: (result.link || '').replace(
              this.props.store.datiFarmacia.siteUrl,
              ''
            ),
            price: result.sale_price || result.price,
            listPrice: result.listprice,
          }));

          if (json.results.length >= 5) {
            options = [
              {
                id: -1,
                image: '',
                name: 'Vedi tutti',
                path: '',
                searchKeywords: input,
              },
              ...options,
            ];
          }

          options = [
            ...options,
            {
              id: -2,
              label: 'Powered by',
              sponsorName: 'Doofinder',
              sponsor: true,
              backgroundColor: 'black',
              searchKeywords: input,
            },
          ];

          return { options };
        })
        .catch(error => {
          // se c'è un errore su doofinder catcho e torno le opzioni di ricerca di default
          console.error(error);
          return this.getOptions(input);
        });
    }
    return Promise.resolve([]);
  };

  getOptionsDoofinderDebounced = debounce(this.getOptionsDoofinder, 1000);

  // LOGIN
  toggleLogin = event => {
    event.preventDefault();

    this.setState({
      showLogin: !this.state.showLogin,
    });
  };

  closeLogin = event => {
    this.setState({
      showLogin: false,
    });
  };

  // MENU
  toggleHeaderMenu = event => {
    event.preventDefault();
    this.closeAll();

    const { showHeaderMenu, headerMenuOpen } = this.props;

    showHeaderMenu(!headerMenuOpen);
  };

  // CART MENU
  toggleCartMenu = event => {
    event.preventDefault();
    this.closeAll();

    this.setState({
      showCartMenu: !this.state.showCartMenu,
    });
  };

  closeCartMenu = event => {
    this.setState({
      showCartMenu: false,
    });
  };

  // CLOSE ALL
  closeAll = event => {
    this.setState({
      showMegaMenu: false,
      selectedMegaMenuType: null,
      showCartMenu: false,
      showLogin: false,
      mobileCategory: null,
      mobileSubCategory: null,
    });
    this.props.showHeaderMenu(false);
  };

  // RENDER
  renderSearchBox = isDesktop => {
    const { isMobile } = this.props;
    return (
      ((!isMobile && isDesktop) || (isMobile && !isDesktop)) && (
        <div className="search-box">
          <AsyncSelect
            isHeader
            id="search-box"
            aria-label="Cerca prodotti nel sito"
            name="keyword-search"
            defaultOptions={[]}
            loadOptions={
              this.props.hasDoofinder
                ? this.getOptionsDoofinderDebounced
                : this.getOptionsDebounced
            }
            openOnClick={false}
            openOnFocus={false}
            autoload={false}
            onInputChange={value => this.setState({ searchKeywords: value })}
            onChange={product => {
              if (product.id > 0) {
                this.props.router.push(product.path);
              }
              if (product.id < 0) {
                this.props.router.push(`/ricerca/${product.searchKeywords}`);
              }
              this.props.showHeaderMenu(false);
            }}
            optionRenderer={product => (
              <ProductAutocomplete
                isDoofinder={this.props.hasDoofinder}
                product={product}
                primaryColor={this.props.primaryColor}
              />
            )}
            arrowRenderer={() => <Search />}
            filterOption={() => true}
            clearable={false}
            autosize={false}
            placeholder="Cerca nel sito"
            loadingPlaceholder="Caricamento..."
            searchPromptText="Digita il nome del prodotto"
          />
        </div>
      )
    );
  };

  setMobileCategory = mobileCategory => {
    if (this.state.mobileCategory === mobileCategory) {
      this.setState({
        mobileCategory: null,
      });
    } else {
      this.setState({
        mobileCategory,
      });
    }
  };

  setMobileSubCategory = mobileSubCategory => {
    if (this.state.mobileSubCategory === mobileSubCategory) {
      this.setState({
        mobileSubCategory: null,
      });
    } else {
      this.setState({
        mobileSubCategory,
      });
    }
  };

  render() {
    const {
      showMegaMenu,
      showCartMenu,
      showLogin,
      selectedMegaMenuType,
    } = this.state;

    const {
      phone,
      phone2,
      user,
      isAuthenticated,
      onLogin,
      primaryColor,
      secondaryColor,
      hasBlog,
      couponPageUrl,
      loghiTemplate,
      loginError,
      categoryTags,
      freeShippingThreshold,
      headerMenuOpen,
      createUser,
      facebookAppId,
      hasFacebookLogin,
      uiVariantMenu,
      uiVariantInputText,
      store,
    } = this.props;

    const bottomMenuStyle = css`
      &.variant-1 {
        .desktop-menu a.link {
          margin: 0 10px;
          padding: 10px;
        }

        .desktop-menu a.link,
        .mobile-menu .user-section .open-login > a,
        .mobile-menu .user-section .welcome-user {
          color: ${primaryColor};
          font-size: 13px;
          background-color: ${primary_light(primaryColor)};
          border-radius: 12px;

          &:focus,
          &:hover,
          &.active {
            color: ${primaryColor};
            background-color: ${primary_s98_l83(secondaryColor)};
          }
        }
      }

      &.variant-2 {
        .desktop-menu a.link {
          margin: 0 10px;
          padding: 10px 9px;
        }
        .desktop-menu a.link,
        .mobile-menu .user-section .open-login > a,
        .mobile-menu .user-section .welcome-user {
          color: ${primaryColor};
          font-size: 13px;
          border-width: 1px;
          border-style: solid;
          border-color: ${primaryColor};

          &:focus,
          &:hover,
          &.active {
            color: #fff;
            background-color: ${primaryColor};
          }
        }
      }

      &.variant-3 {
        .desktop-menu a.link,
        .mobile-menu .user-section .open-login > a,
        .mobile-menu .user-section .welcome-user {
          color: ${primary_s15_l20(primaryColor)};
          font-size: 12px;
          text-transform: uppercase;

          &:focus,
          &:hover,
          &.active {
            color: ${primaryColor};
          }
        }

        .desktop-menu a.link {
          margin: 0 8px;

          &.active svg {
            transform: rotate(180deg);
            transition: all 0.3s ease-in-out;
          }

          svg {
            margin-left: 10px;
            transform: rotate(0);
            transition: all 0.3s ease-in-out;
          }
        }
      }

      .desktop-menu > a.link {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;

        &:first-of-type {
          margin-left: 0;
        }
        &:last-of-type {
          margin-right: 0;
        }
      }

      .mobile-menu > a.link {
        &:focus,
        &:hover {
          color: ${primaryColor};
        }
      }
    `;
    return (
      <div className={`header-menu ${showMegaMenu ? 'mega-menu-open' : ''}`}>
        <nav className="navbar navbar-expand-lg" role="navigation">
          {/* TOP MENU */}
          <div className="top">
            <div className="container container-wide">
              <div className="d-flex flex-row align-items-center justify-content-between">
                <div className="left-header">
                  <Button
                    type="button"
                    className="navbar-toggler"
                    data-toggle="collapse"
                    data-target="#menu"
                    aria-expanded="false"
                    onClick={this.toggleHeaderMenu}
                    style={{ color: primaryColor }}
                  >
                    <span className="sr-only">Toggle navigation</span>
                    {headerMenuOpen ? <FiX /> : <FiMenu />}
                  </Button>

                  <IndexLink
                    to="/"
                    onClick={this.closeAll}
                    className="navbar-brand"
                    activeClassName="active"
                    aria-label={`Torna alla home page`}
                  >
                    <ImageDispatcher
                      alt={`Logo ${this.props.store.datiFarmacia.siteName}`}
                      src={loghiTemplate.logoImage}
                    />
                  </IndexLink>
                </div>

                <div className="center-header">
                  {this.renderSearchBox(true)}
                  <div className="info-1">
                    <div className="icon" style={{ color: primaryColor }}>
                      <Spedizione />
                    </div>
                    <div className="text">
                      <div>{store.home.shippingDescription}</div>
                      <div>
                        <b>
                          Gratuita oltre{' '}
                          <Price amount={freeShippingThreshold} />
                        </b>
                      </div>
                    </div>
                  </div>
                  <div className="info-2">
                    <div className="icon" style={{ color: primaryColor }}>
                      <Assistenza />
                    </div>
                    <div className="text">
                      {!!phone && (
                        <div>
                          <b>
                            Assistenza Clienti{' '}
                            <a
                              href={'tel:' + phone}
                              style={{ color: primaryColor }}
                            >
                              {phone}
                            </a>
                          </b>
                        </div>
                      )}
                      {!!phone2 && (
                        <div>
                          <b>
                            Whatsapp{' '}
                            <a
                              href={'https://wa.me/' + phone2}
                              style={{ color: primaryColor }}
                            >
                              {phone2}
                            </a>
                          </b>
                        </div>
                      )}
                      <div className="small">
                        {loghiTemplate.headerLine1}
                        <br />
                        {loghiTemplate.headerLine2}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="right-header">
                  <CartMenu
                    showCartMenu={showCartMenu}
                    onToggleCartMenu={this.toggleCartMenu}
                    onCloseCartMenu={this.closeCartMenu}
                    onCloseAll={this.closeAll}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* BOTTOM MENU */}
          <div
            className={`bottom variant-${uiVariantMenu}`}
            css={bottomMenuStyle}
          >
            {this.renderSearchBox(false)}
            <div
              className={`navbar-collapse collapse ${
                headerMenuOpen ? 'show' : ''
              } justify-between`}
              id="menu"
            >
              {!this.props.isMobile && (
                <div className="container">
                  <div className="desktop-menu">
                    {categoryTags &&
                      categoryTags.map(tag => (
                        <Link
                          key={tag.name}
                          to="#"
                          className={`link ${
                            selectedMegaMenuType === tag.name ? 'active' : ''
                          }`}
                          onClick={this.toggleMegaMenu(tag.name)}
                        >
                          {tag.name}
                          {uiVariantMenu === '3' && <FaChevronDown />}
                        </Link>
                      ))}

                    {!!this.getCategories('farmaci').length && (
                      <Link
                        to="/farmaci"
                        className={`link ${
                          selectedMegaMenuType === 'farmaci' ? 'active' : ''
                        }`}
                        onClick={this.toggleMegaMenu('farmaci')}
                      >
                        Farmaci
                        {uiVariantMenu === '3' && <FaChevronDown />}
                      </Link>
                    )}
                    {!!this.getCategories('prodotti').length && (
                      <Link
                        to="/prodotti"
                        className={`link ${
                          selectedMegaMenuType === 'prodotti' ? 'active' : ''
                        }`}
                        onClick={this.toggleMegaMenu('prodotti')}
                      >
                        Prodotti
                        {uiVariantMenu === '3' && <FaChevronDown />}
                      </Link>
                    )}
                  </div>
                </div>
              )}

              {!!this.props.isMobile && (
                <div className="mobile-menu">
                  <div className="user-section">
                    <div className="container">
                      {!isAuthenticated ? (
                        <Login
                          user={user}
                          isAuthenticated={isAuthenticated}
                          onLogin={onLogin}
                          showLogin={showLogin}
                          onToggleLogin={this.toggleLogin}
                          onCloseLogin={this.closeLogin}
                          loginError={loginError}
                          primaryColor={primaryColor}
                          onCloseAll={this.closeAll}
                          isInMobileMenu
                          onLoginFacebook={this.props.onLoginFacebook}
                          facebookAppId={facebookAppId}
                          hasFacebookLogin={hasFacebookLogin}
                          createUser={createUser}
                          uiVariantInputText={uiVariantInputText}
                        />
                      ) : (
                        <Link
                          to="/profilo"
                          className="welcome-user"
                          onClick={this.closeAll}
                        >
                          <LoginIcon /> Ciao{' '}
                          {user && user.billing && user.billing.firstname}
                        </Link>
                      )}
                    </div>
                  </div>
                  {!!this.getCategories('prodotti').length && (
                    <>
                      <a
                        href="#"
                        className="link"
                        onClick={() => this.setMobileCategory('prodotti')}
                        activeClassName="active"
                        style={{
                          borderBottom:
                            this.state.mobileCategory === 'prodotti' ? 0 : '',
                        }}
                      >
                        <div className="container">Prodotti</div>
                      </a>
                      {this.state.mobileCategory === 'prodotti' &&
                        this.props.categories
                          .filter(cat => cat.type === 'prodotti')
                          .map(category => (
                            <>
                              <a
                                href="#"
                                className="link mobile-category"
                                activeClassName="active"
                              >
                                <div
                                  onClick={() =>
                                    this.setMobileSubCategory(category.name)
                                  }
                                  className="container"
                                  style={{ paddingLeft: 30, fontSize: 10 }}
                                >
                                  {category.name}
                                </div>
                              </a>
                              {this.state.mobileCategory === 'prodotti' &&
                                this.state.mobileSubCategory ===
                                  category.name &&
                                category.subcategories.map(subcategory => (
                                  <Link
                                    to={`/prodotti/${category.seoName}/${subcategory.seoName}`}
                                    className="link mobile-category"
                                    onClick={this.closeAll}
                                    activeClassName="active"
                                  >
                                    <div
                                      className="container"
                                      style={{ paddingLeft: 45, fontSize: 10 }}
                                    >
                                      {subcategory.name}
                                    </div>
                                  </Link>
                                ))}
                            </>
                          ))}
                    </>
                  )}
                  {!!this.getCategories('farmaci').length && (
                    <>
                      <a
                        href="#"
                        className="link"
                        onClick={() => this.setMobileCategory('farmaci')}
                        activeClassName="active"
                        style={{
                          borderBottom:
                            this.state.mobileCategory === 'farmaci' ? 0 : '',
                        }}
                      >
                        <div className="container">Farmaci</div>
                      </a>
                      {this.state.mobileCategory === 'farmaci' &&
                        this.props.categories
                          .filter(cat => cat.type === 'farmaci')
                          .map(category => (
                            <>
                              <a
                                href="#"
                                className="link mobile-category"
                                activeClassName="active"
                              >
                                <div
                                  onClick={() =>
                                    this.setMobileSubCategory(category.name)
                                  }
                                  className="container"
                                  style={{ paddingLeft: 30, fontSize: 10 }}
                                >
                                  {category.name}
                                </div>
                              </a>
                              {this.state.mobileCategory === 'farmaci' &&
                                this.state.mobileSubCategory ===
                                  category.name &&
                                category.subcategories.map(subcategory => (
                                  <Link
                                    to={`/prodotti/${category.seoName}/${subcategory.seoName}`}
                                    className="link mobile-category"
                                    onClick={this.closeAll}
                                    activeClassName="active"
                                  >
                                    <div
                                      className="container"
                                      style={{ paddingLeft: 45, fontSize: 10 }}
                                    >
                                      {subcategory.name}
                                    </div>
                                  </Link>
                                ))}
                            </>
                          ))}
                    </>
                  )}
                  <Link
                    to="/prodotti-in-offerta"
                    className="link"
                    onClick={this.closeAll}
                  >
                    <div className="container">Offerte</div>
                  </Link>
                  {!!hasBlog && (
                    <Link to="/blog" className="link" onClick={this.closeAll}>
                      <div className="container">Blog</div>
                    </Link>
                  )}
                  <Link
                    to="/pagine/contattaci"
                    className="link"
                    onClick={this.closeAll}
                  >
                    <div className="container">Contatti</div>
                  </Link>
                  <Link
                    to="/pagine/servizi"
                    className="link"
                    onClick={this.closeAll}
                  >
                    <div className="container">Servizi</div>
                  </Link>
                  <Link
                    to="/pagine/info-acquisti"
                    className="link"
                    onClick={this.closeAll}
                  >
                    <div className="container">Info acquisti</div>
                  </Link>
                  {!!hasBlog && !!couponPageUrl && (
                    <A
                      className="link"
                      href={couponPageUrl}
                      onClick={this.closeAll}
                    >
                      <div className="container">Coupon</div>
                    </A>
                  )}
                </div>
              )}
            </div>
          </div>
        </nav>

        <MegaMenu
          type={this.state.selectedMegaMenuType}
          showMegaMenu={showMegaMenu}
          categories={this.getCategories(this.state.selectedMegaMenuType)}
          onLinkClick={this.closeAll}
          primaryColor={primaryColor}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isMobile: state.layout.isMobile,
    store: state.store.data,
    storeId: state.store.data.storeId,
    categories: state.categories.data.categories,
    categoryTags: state.categories.data.tags,
    facebookAppId: state.store.data.integrazioni.facebook.appId,
    hasBlog: state.store.data.features.hasBlog,
    hasFacebookLogin: state.store.data.features.hasFacebookLogin,
    hasDoofinder: state.store.data.features.hasDoofinder,
    doofinderHashId: state.store.data.integrazioni.doofinder.hashId,
    couponPageUrl: state.store.data.funzionalita.couponPageUrl,
    loghiTemplate: state.store.data.loghiTemplate,
    phoneImage: state.store.data.loghiTemplate.phoneImage,
    loginError: state.user.error,
    freeShippingThreshold:
      state.store.data.costiSpedizione.freeShippingThreshold,
    headerMenuOpen: state.showHeaderMenu.headerMenuOpen,
    uiVariantMenu: state.store.data.uiVariants.menu,
    uiVariantInputText: state.store.data.uiVariants.inputText,
    hasGoogleAnalytics4Advanced: !!state.store.data.features
      .hasGoogleAnalytics4Advanced,
    hasGoogleTagManager: !!state.store.data.features.hasGoogleTagManager,
    hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
  };
}

export default withRouter(
  connect(mapStateToProps, { showHeaderMenu })(HeaderMenu)
);
